// nonconformance views
const Nonconformance = () => import("Modules/manufacturing/nonconformance/views/Nonconformance");
const Profile = () => import("Modules/manufacturing/nonconformance/views/Profile");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "nonconformance",
            name: "nonconformance",
            component: Nonconformance,
            meta: {
                requiresAuth: true,
                title: "lang.nonconformance",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["nonconformance.read"],
            },
        },
        {
            path: "nonconformance/:id?",
            name: "nonconformance_profile",
            component: Profile,
            meta: {
                requiresAuth: true,
                title: "lang.nonconformance",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["nonconformance.read"],
            },
        },
    ],
};
